@if (isSourceReady()) {
  <iframe title="eua iframe" [src]="trustedSource"></iframe>
}